import React from 'react'

import useSwr from 'swr'
import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { TiposTablaComunConstant } from 'constants/index'

import * as TablaComunService from 'services/tablasComunes.service'

const fetcher = () =>
  TablaComunService.getAsSelect(TiposTablaComunConstant.SUNAT_ESTADO_ACTIVO_FIJO).then(({ data }) => data)

const EstadoActivoFijoSunatFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const { data: estados } = useSwr('select_sunat_estado_activo_fijo', fetcher, {
    initialData: [],
    revalidateOnMount: true,
    revalidateOnFocus: false
  })

  return (
    <Form.Group>
      <Form.Label text='ESTADO SUNAT' htmlFor='select-estadoActivoFijoSunat' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='estadoActivoFijoSunat'>
          {({ field }) => (
            <Form.Select {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='select-estadoActivoFijoSunat'>
              <option value=''>Seleccionar</option>
              {estados.map((val, key) => (
                <option key={key} value={val._id}>
                  {val.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(EstadoActivoFijoSunatFormGroup)
